import React, { lazy } from 'react'

const LoginPage = lazy(() => import('./LoginPage'))

export { LoginPage }
